// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/refresh-cw.js';

import { paths } from '../generated/refresh-cw';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('refresh-cw', Original, paths);
